<div [class.rtl]="currLang == 'ar'" class="modal" id="deleteModal" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="sub-header">
          <h5 class="modal-title">{{'delete-modal.delete-from-system'|translate}}</h5>
          <span *ngIf="rowsType==='gates'">{{'delete-modal.confirm-deleting'|translate}}{{gate.name}}</span>
          <span *ngIf="rowsType==='grades'">{{'delete-modal.confirm-deleting'|translate}}{{grade.name}}</span>
          <span
            *ngIf="rowsType !== 'gates' &&  rowsType !== 'grades' && rowsType !== 'listing'">{{'delete-modal.confirm-deleting'|translate}}  {{toBeDeletedRows?.length}}  {{rowsType}}</span>
            <span
            *ngIf="rowsType==='listing'">{{'delete-modal.confirm-deleting'|translate}}  {{toBeDeletedRows?.length}}  {{delegationMsg}}</span>
          </div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <span>{{'delete-modal.enter-password'|translate}}</span>
        <input type="text" [(ngModel)]="password" #passwordRef>
        <span class="error" *ngIf="passwordMismatch">{{passwordMismatch}}</span>
      </div>
      <div class="modal-footer">
        <button [disabled]="password?.length > 0 ? false : true" (click)="deleteRows()" type="button"
          class="btn btn-primary">{{getConfirmBtnLabel()}}</button>
        <button type="button" class="btn btn-secondary"
          data-dismiss="modal">{{'delete-modal.cancel'|translate}}</button>
      </div>
    </div>
  </div>
</div>
<app-error-msg></app-error-msg>